package org.lennycodes.gradematewebsite

import kotlinx.coroutines.await

suspend fun login(
    email: String,
    password: String
): Boolean {

    return try {

        signInWithEmailAndPassword(
            FirebaseService.auth,
            email,
            password
        ).await()


        console.log("Firebase login successful")

        true


    } catch (e: Throwable) {


        console.error(
            "Firebase login failed: ${e.message}"
        )

        false

    }

}